import React from "react";

import appConfig from "@/config/appConfig";

const Footer = () => {
  return (
    <footer className="mt-auto position-sticky bottom-0" style={{ zIndex: 100 }}>
      <div className="footer">
        {/* <div className={`container-fluid justify-content-center ${isDark ? "bg-black-1" : "bg-light"}`}> */}
        <div className={`container-fluid justify-content-center`} style={{ background: "var(--bs-body-bg)" }}>
          <div className="d-block d-md-flex w-100 py-2 ">
            <p className="py-2 mb-0 mx-auto text-center">{appConfig.copyright}</p>
            <p className="py-2 mb-0 text-center text-md-end">Version {appConfig.version}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
